import 'whatwg-fetch'
import Vue from 'vue'
import delve from 'dlv'

let endpoint = ''
let state = {}
if (process.env.NODE_ENV === 'development') {
  window.contentstate = state
}

const api = (opts = {}) => {
  endpoint = opts.endpoint || '' // global

  return {
    beforeRouteEnter: handleRoute,
    beforeRouteUpdate: handleRoute
  }

  function handleRoute(to, from, next) {
    // WP specific hack here since wp-json forces us to
    // use `/home` instead of `/` for homepage, once loaded
    // route is stored in $store as `/` though so lookup and etc
    // are unaffected
    let path = to.path === '/' ? '/home' : to.path
    let urls = [path]

    // handle route specific requests
    if (to.meta.contentState) {
      // if route does not need to fetch,
      // immediately call next
      if (to.meta.contentState.disable) {
        next()
        if (typeof opts.loadEnd === 'function') opts.loadEnd()
        return
      }

      // if route supports query parameters,
      // also fetch route with parameters
      if (to.meta.contentState.params && to.path !== to.fullPath) {
        urls.push(to.fullPath)
      }

      // if route supports pagination and currently
      // no pagination, fetch first page
      if (to.meta.contentState.pagination && to.path === to.fullPath) {
        urls.push(to.path + '?page=1')
      }
    }

    // filter urls by those which we need to load
    let urlsToLoad = urls.filter(url => {
      return opts.$store.getters.getShouldLoad(url)
    })

    // load urls
    if (urlsToLoad.length) {
      if (typeof opts.loadStart === 'function') opts.loadStart()

      // partial load skip
      // let partiallyLoaded = urlsToLoad.find(url => {
      //   return opts.$store.getters.getPartiallyLoaded(url)
      // })
      // if (partiallyLoaded) {
      //   next()
      //   // console.log(partiallyLoaded)
      // }

      opts.$store.dispatch('fetchPages', urlsToLoad)
        .then(() => {
          next()
          if (typeof opts.loadEnd === 'function') opts.loadEnd()
        })
    } else {
      next()
    }
  }
}

const mod = {
  state: state,
  actions: {
    fetchPages({ commit }, urls) {
      return Promise.all(urls.map(url => {
        return fetchPage(url).then((pages = {}) => {
          commit('setPages', { pages })
        })
      }))
    },
    fetchPage({ commit }, url) {
      return fetchPage(url).then((pages = {}) => {
        commit('setPages', { pages })
      })
    },
    updatePages({ commit }, { pages }) {
      commit('setPages', { pages })
    }
  },
  mutations: {
    setPages(state, { pages }) {
      Object.keys(pages).forEach(key => {
        let entry = state[key]
        if (!entry || (entry && entry._loaded !== true)) {
          Vue.set(state, key, pages[key])
        }
      })
    },
    setPage(state, { url, page }) {
      Vue.set(state, url, page)
    }
  },
  getters: {
    getPage: state => key => {
      return state[key]
    },
    getPages: state => keys => {
      return keys && Array.isArray(keys)
        ? keys.map(key => state[key]).filter(x => x)
        : []
    },
    getShouldLoad: state => key => {
      let entry = state[key]
      if (!entry || (entry && entry._loaded !== true)) {
        return true
      }
    },
    getPartiallyLoaded: state => key => {
      let entry = state[key]
      if (entry && entry._loaded === false) return true
    },
    getThumbnail: () => (page = {}) => {
      let thumb = undefined
      if (page.thumbnail) {
        thumb = page.files[page.thumbnail]
      }
      if (!thumb && Array.isArray(page.files)) {
        thumb = page.files[0]
      }
      return thumb
    }
  }
}

const mixin = {
  computed: {
    site() {
      return this.$store.getters.getPage('star')
    },
    page() {
      let path = normalizePath(this.$route.path)
      return this.$store.getters.getPage(path) || {}
    },
    pages() {
      return this.$store.getters.getPages(delve(this, 'page.pages'))
    },
    thumbnail() {
      return this.$store.getters.getThumbnail(this.page)
    },
    qpage() {
      if (delve(this.$route, 'meta.contentState.params')) {
        let init = normalizePath(this.$route.path)
        let full = normalizePath(this.$route.fullPath)

        let path = full !== init
          ? full
          : init + '?page=1'

        return this.$store.getters.getPage(path)
      } else return {}
    },
    qpages() {
      return this.$store.getters.getPages(delve(this, 'qpage.pages'))
    }
  }
}

function fetchPage(url) {
  return new Promise(function (resolve, reject) {
    fetch(endpoint + url)
      .then(resp => resp.json())
      .then(json => {
        if (json.status === 'error') resolve({ [url]: { _error: 'Could not load' } })
        else resolve(json)
      })
      .catch(reject)
  })
}

function normalizePath(path) {
  return path.replace(/\/$/, '').replace('/?', '?') || '/'
}

export { api, mod, mixin }
export default { api, mod, mixin }